import { render, staticRenderFns } from "./IconSvgEllipsis.vue?vue&type=template&id=040b966f&scoped=true&"
import script from "./IconSvgEllipsis.vue?vue&type=script&lang=js&"
export * from "./IconSvgEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b966f",
  null
  
)

export default component.exports